import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '@spark';
import FieldLabel from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/FieldLabel';

/**
 * Single-line text field with the Figma label row (required asterisk + help
 * tooltip) on top of a Spark `Input`.
 */
const TextField = ({
    label,
    required = false,
    help,
    placeholder,
    value,
    onChange,
    error = false,
    errorText = '',
    disabled = false,
    readOnly = false,
}) => (
    <div className="gdai-field">
        <FieldLabel text={label} required={required} help={help} />
        <Input
            showLabel={false}
            size="medium"
            placeholder={placeholder}
            value={value}
            danger={error || Boolean(errorText)}
            disabled={disabled}
            readOnly={readOnly}
            onChange={(event) => onChange(event.target.value)}
        />
        {errorText ? (
            <p className="gdai-field-hint gdai-field-hint--error fs-unmask" role="alert">
                {errorText}
            </p>
        ) : null}
    </div>
);

TextField.propTypes = {
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
    help: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    error: PropTypes.bool,
    errorText: PropTypes.string,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
};

export default TextField;
